var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { checkboxClasses } from '@mui/material/Checkbox';
import MuiChip, { chipClasses } from '@mui/material/Chip';
import { XIcon } from '../icon';
import { fade } from '../styles/color-manipulator';
import { styled } from '../styled';
export var chipComponentName = 'QuantumChip';
// TODO: padding left is 8px only if chip has a checkbox. Right now the override is for any chip.
var Root = styled(MuiChip, { name: chipComponentName, slot: 'Root' })(function (_a) {
    var _b, _c;
    var theme = _a.theme, disabled = _a.disabled, ownerState = _a.ownerState;
    return (__assign(__assign(__assign({}, (disabled && {
        opacity: 1,
        pointerEvents: 'none',
        backgroundColor: theme.tokens.color_bg_disabled,
    })), (_b = {}, _b[".".concat(checkboxClasses.root)] = {
        padding: theme.spacing(1),
    }, _b)), (ownerState.selected && (_c = {
            boxShadow: theme.mixins.borderAsBoxShadow(theme.tokens.color_border_selected, 1),
            borderColor: theme.tokens.color_border_selected,
            transition: theme.transitions.create(['box-shadow', 'border-color'], {
                duration: theme.transitions.duration.shortest,
            })
        },
        _c["&.".concat(chipClasses.disabled)] = {
            boxShadow: theme.mixins.borderAsBoxShadow(theme.tokens.color_border_disabled_selected, 1),
            borderColor: theme.tokens.color_border_disabled_selected,
        },
        _c["&:hover:not(&.".concat(chipClasses.disabled, ")")] = {
            boxShadow: "".concat(theme.mixins.borderAsBoxShadow(theme.tokens.color_border_selected, 1)),
            borderColor: theme.tokens.color_border_selected,
            backgroundColor: theme.tokens.color_bg_link_hover,
            transition: theme.transitions.create(['box-shadow', 'border-color'], {
                duration: theme.transitions.duration.shortest,
            }),
        },
        _c["&:focus:not(&.".concat(chipClasses.disabled, ")")] = {
            boxShadow: "".concat(theme.mixins.borderAsBoxShadow(theme.tokens.color_border_selected, 1), ", ").concat(fade(theme.tokens.color_border_focus, 0.25), " 0px 0px 0px 0.25em"),
            borderColor: theme.tokens.color_border_selected,
            transition: theme.transitions.create(['box-shadow', 'border-color'], {
                duration: theme.transitions.duration.shortest,
            }),
        },
        _c[".".concat(checkboxClasses.colorPrimary, ".").concat(checkboxClasses.checked, ":not(.").concat(checkboxClasses.disabled, ")")] = {
            color: theme.tokens.color_bg_selected,
        },
        _c))));
});
export var Chip = React.forwardRef(function (props, ref) {
    var selected = props.selected, _a = props.deleteIcon, deleteIcon = _a === void 0 ? React.createElement(XIcon, null) : _a, chipProps = __rest(props, ["selected", "deleteIcon"]);
    return React.createElement(Root, __assign({ ref: ref, deleteIcon: deleteIcon, ownerState: { selected: selected } }, chipProps));
});
